import comp from "./GqlWithLoader";
export default comp;
